exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".position-title {\n  margin-top: 0;\n}\n\ntext-center {\n  text-align: center;\n}\n\n.domain-item {\n  padding-top: 3px;\n  padding-left: 3px;\n}\n\n.domain-item__button {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/voucher/voucher-domains/voucher-domains.component.css
// module id = ../../../../../src/app/modules/voucher/voucher-domains/voucher-domains.component.css
// module chunks = main